
import { Component, Prop, Vue } from "nuxt-property-decorator";
import SortHeader from "~/components/molecules/nav/SortHeader.vue";
import DealerOfferList from "../molecules/display/DealerOfferList.vue";

@Component({
  components: {
    DealerOfferList,
    SortHeader,
  },
})
export default class PriceOffersSection extends Vue {
  @Prop({ required: true }) dealerOffers!: any[];
  @Prop({ required: true }) showPriceOffers!: boolean;
  @Prop({ required: true }) dealRequirements!: any;
  @Prop({ required: true }) sortOptions!: any;
  @Prop({ default: "" }) errorMessage!: string;
  @Prop({ default: false }) showPaletColumn!: boolean;
  @Prop({ default: "" }) selectPelletsOption!: string;
  @Prop({ default: false }) isPelletsSite!: boolean;
  @Prop({
    default:
      'Bitte bestätigen Sie den "Rechnen" Button, um Ihre aktualisierten Ergebnisse zu erhalten.',
  })
  overlayMessage!: string;
}
